module.exports = __webpack_public_path__ + "img/Rectangle 19.1943d614.png";